<template>
    <div class="row justify-content-center mt-5">
        <div class="col col-md-3 col-sm-6">
            <IconCard type="router" link="/events" image="/img/svg/calendar.svg" title="Events" sub-title="registration"></IconCard>
        </div>
        <div class="col col-md-3 col-sm-6">
            <IconCard type="link" link="https://glimpses.kristujayanti.edu.in/" image="/img/svg/newsletter.svg" title="Glimpses" sub-title="newsletter"></IconCard>
        </div>
        <div class="col col-md-3 col-sm-6">
            <IconCard type="link" link="https://play.google.com/store/apps/details?id=com.kristujayanti.app" image="/img/svg/app.svg" title="KJC Plus" sub-title="application"></IconCard>
        </div>
        <div class="col col-md-3 col-sm-6">
            <IconCard v-if="$currentUser == null" type="router" link="/dashboard" image="/img/svg/login-icon.svg" title="Login" sub-title="for in-house users"></IconCard>
            <IconCard v-else type="router" link="/dashboard" image="/img/svg/login-icon.svg" title="Dashboard" sub-title="for in-house users"></IconCard>
        </div>
    </div>
</template>

<script>
import { IconCard } from 'src/components';

export default {
    name: 'Home',
    components:{
        IconCard
    }
}
</script>

<style lang="scss">
</style>
